export function StyleSheet() {
    return (
        <style>{`


        .progress {
            position: fixed;
            left: 0;
            right: 0;
            height: 5px;
            background: #8df0cc;
            bottom: 50px;
            transform: scaleX(0);
        }
    `} </style>
    )
}